import React from 'react'

const RightPage6 = () => {
  return (
    <div id="Projects" className='px-6 py-12'>
         <h2 className="text-3xl font-bold text-black relative inline-block">
        Projects
        {/* Underline */}
        <span className="block w-10 h-1 bg-blue-400 mt-2"></span>
      </h2>
      <h3 className="font-semibold pt-14">Final year project</h3>  
      <p className=" italic">Monitoring and protection of single phase induction
 motor using wifi module </p>   
 <ul className="list-disc ml-4 text-sm">
        <li>Designed and implemented a smart system to monitor and protect a single-phase induction motor using a WiFi module for remote access</li>
        <li>Integrated real-time monitoring of motor parameters such as voltage, current, and temperature.</li>
        <li>Developed an automatic shutdown feature to prevent damage during fault conditions or abnormal loads.</li>
        <li>Enabled wireless data transmission to a mobile or web dashboard for easy tracking and control.</li>
        <li>Enhanced motor safety and efficiency by combining IoT technology with conventional protection techniques.</li>
      </ul>  
       <h3 className="font-semibold pt-14"> TECHNICAL PROJECTS</h3>  
      <p className=" italic">IoT Programmable Sensor-Based Line Following Robot </p>   
 <ul className="list-disc ml-4 text-sm">
        <li>Developed a programmable line-following robot equipped with sensors to detect and follow a designated path.</li>
        <li>Integrated IoT functionality for remote monitoring and control of robot movements and queue status.</li>
        <li>Designed to manage queues efficiently by guiding people or objects in an organized sequence.</li>
        <li>Used microcontrollers and wireless modules to enable real-time communication and updates.</li>
        <li>Improved automation and reduced manual intervention in queue management systems for smart environments.</li>
      </ul>    
    </div>
  )
}

export default RightPage6
